import PropTypes from 'prop-types';
import cc from 'classcat';

import { customThemes } from '../../../lib/themes';

import styles from './styles.module.scss';

const Arrow = ({ theme, direction, className, onClick, pathClassName }) => (
  <svg
    role="img"
    viewBox="0 0 11 17"
    className={cc([className, styles.container, styles[direction]])}
    onClick={onClick}
  >
    <path
      className={cc([styles.path, styles[theme], pathClassName])}
      d="M0,15.7115702 C0,15.3652164 0.124685508,15.0673565 0.374060265,14.8179818 L6.71230364,8.50051954 L0.374060265,2.18305729 C0.124685508,1.93368253 0,1.62889573 0,1.26868775 C0,0.908479768 0.124685508,0.610619944 0.374060265,0.37509934 C0.623435022,0.139578736 0.928221819,0.0148932282 1.2884298,0.00103907505 C1.64863778,-0.0128150781 1.94649761,0.11187043 2.18201821,0.37509934 L10.2866573,8.50051954 L2.18201821,16.6259397 C1.9187893,16.8753145 1.62092948,17 1.2884298,17 C0.955930125,17 0.658070301,16.8753145 0.394841391,16.6259397 C0.131612481,16.376565 0,16.0717782 0,15.7115702 Z"
    />
  </svg>
);

Arrow.propTypes = {
  theme: PropTypes.oneOf(customThemes('dark', 'light', 'none')),
  direction: PropTypes.oneOf(['up', 'right', 'down', 'left']),
  className: PropTypes.string,
  onClick: PropTypes.func,
};

Arrow.defaultProps = {
  theme: 'dark',
  direction: 'right',
};

export default Arrow;
